<template>
  <div></div>
</template>

<script>
import fetchV2 from '../assets/js/fetchV2';

export default {
  name: 'Reset',

  methods: {
    reset() {
      fetchV2('POST /users/reset', {
        v: this.$route.query.v.trim().toLowerCase(),
        w: this.$route.query.w,
        x: this.$route.query.x,
        y: this.$route.query.y,
        z: this.$route.query.z,
      }).then(data => {
        if (data != null && data.permissions != null) {
          this.$emit('permissions', data.permissions);
          this.$router.replace('/dashboard/change-password')
        }
      }).catch((err) => {
        console.error(err);
        this.$emit('error', 'Security challenge error.');
      })
    }
  },

  created () {
    this.reset();
  },
};
</script>
